import { booleanResultResolver, useAbeetResult } from '@clutter/abeet';

import { useAbeetVisitorTest } from '@shared/abeet';

export function useCouponDefaultTest() {
  const result = useAbeetResult('web_visitor_coupon_default');
  return result
    ? {
        promoCode: result.promo_code,
        expirationDate: result.expiration_date,
      }
    : {};
}

export function useDisposalServiceSmokeTest() {
  return (
    useAbeetResult('web_visitor_disposal_smoke_test', {
      resolver: booleanResultResolver('enabled'),
    }) || false
  );
}

export function useTermsWithSubjobPackagesTest() {
  const result = useAbeetVisitorTest('web_visitor_labor', {
    resolver: booleanResultResolver('subjob_packages'),
  })[0];
  return result || false;
}

export function useCalendarCouponTest() {
  return (
    useAbeetVisitorTest('web_visitor_calendar_coupon', {
      resolver: booleanResultResolver('enabled'),
    })[0] || false
  );
}
